class CustomGridySlider extends customElements.get('gridy-slider') {
  constructor() {
    super();
    if (!this.config.is_thumbnails_slider) {
      this.track.classList.add('disable-scroll');
      this._initSwipe();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._swipeInitialized) {
      this.track.removeEventListener('pointerdown', this._boundOnSwipeStart, { passive: false });
      this.track.removeEventListener('pointermove', this._boundOnSwipeMove, { passive: false });
      this.track.removeEventListener('pointerup', this._boundOnSwipeEnd);
      this.track.removeEventListener('pointercancel', this._boundOnSwipeEnd);
      this.track.removeEventListener('click', this._boundOnSwipeClick, { capture: true });
      clearTimeout(this._swipeState?.suppressTimeout);
    }
  }

  _initSwipe() {
    this._swipeInitialized = true;
    this._swipeState = { startX: 0, startY: 0, active: false, direction: null, pendingPosition: null, suppressNextClick: false, suppressTimeout: null };
    this.track.style.touchAction = 'pan-y';
    this._boundOnSwipeStart = this._onSwipeStart.bind(this);
    this._boundOnSwipeMove = this._onSwipeMove.bind(this);
    this._boundOnSwipeEnd = this._onSwipeEnd.bind(this);
    this._boundOnSwipeClick = this._onSwipeClick.bind(this);
    this.track.addEventListener('pointerdown', this._boundOnSwipeStart, { passive: false });
    this.track.addEventListener('pointermove', this._boundOnSwipeMove, { passive: false });
    this.track.addEventListener('pointerup', this._boundOnSwipeEnd);
    this.track.addEventListener('pointercancel', this._boundOnSwipeEnd);
    this.track.addEventListener('click', this._boundOnSwipeClick, { capture: true });
  }

  _onSwipeStart(event) {
    this._swipeState.startX = event.clientX;
    this._swipeState.startY = event.clientY;
    this._swipeState.active = true;
    this._swipeState.direction = null;
    this._swipeState.pendingPosition = null;
  }

  _onSwipeMove(event) {
    if (!this._swipeState.active) return;

    const dx = event.clientX - this._swipeState.startX;
    const dy = event.clientY - this._swipeState.startY;

    if (this._swipeState.direction !== null) {
      event.preventDefault();
      return;
    }

    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);

    if (absDx < 5 && absDy < 5) return;

    if (absDy > absDx) {
      this._swipeState.active = false;
      return;
    }

    if (absDx < 20) return;

    event.preventDefault();
    const direction = dx < 0 ? 'next' : 'prev';
    this._swipeState.direction = direction;

    const currentIPR = this.config.currentIPR;
    const slideMultiplier = this.config.sliding_behavior === 'all' ? currentIPR : 1;
    const lastToShow = this.config.slide_count - currentIPR;
    let newPosition = this.config.current_slide;

    if (direction === 'next') {
      newPosition += slideMultiplier;
      if (this.config.current_slide === lastToShow) newPosition = 0;
      else if (newPosition > lastToShow) newPosition = lastToShow;
    } else {
      newPosition -= slideMultiplier;
      if (this.config.current_slide > 0 && newPosition < 0) newPosition = 0;
      else if (newPosition < 0) newPosition = lastToShow;
    }

    this._swipeState.pendingPosition = newPosition;
  }

  _onSwipeClick(event) {
    if (!this._swipeState.suppressNextClick) return;
    this._swipeState.suppressNextClick = false;
    clearTimeout(this._swipeState.suppressTimeout);
    event.stopPropagation();
    event.preventDefault();
  }

  _onSwipeEnd(event) {
    if (!this._swipeState.active) return;
    this._swipeState.active = false;

    if (this._swipeState.pendingPosition !== null) {
      this.config.current_slide = this._swipeState.pendingPosition;

      this.track.style.scrollSnapType = 'none';
      this.scrollToSlide(this._swipeState.pendingPosition);

      const restoreSnap = () => { this.track.style.scrollSnapType = ''; };
      this.track.addEventListener('scrollend', restoreSnap, { once: true });
      clearTimeout(this._snapRestoreTimeout);
      this._snapRestoreTimeout = setTimeout(restoreSnap, 600);

      this._swipeState.suppressNextClick = true;
      clearTimeout(this._swipeState.suppressTimeout);
      this._swipeState.suppressTimeout = setTimeout(() => {
        this._swipeState.suppressNextClick = false;
      }, 300);
    }
  }
}

customElements.define('custom-gridy-slider', CustomGridySlider);
